import React, { useEffect, useRef, useState } from 'react';
import { useData } from '../../../../contexts';
import { AccordionThema } from './AccordionThema';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import { MdClose, MdFilterAltOff } from 'react-icons/md';
import { Menu, MenuItem } from 'react-pro-sidebar';
import { Modal } from '@mui/base';
import { Backdrop } from '@mui/material';
import { DropdownGemeenteBench } from './DropdownGemeenteBench';

export const SelectionPanel = (props: any) => {
  const {
    themas,
    indicatorThema,
    gemeenteLijst,
    selectedGemeente,
    selectedBenchmarks,
    benchmarkLijst,
    open,
    setOpen,
    d_ruimte,
  } = props;

  const {
    interfaceColor,
    setSelectedGemeente,
    setSelectedBenchmarks,
    setSelectedIndicators,
    setSelectedIndicator,
    globalSourceFilter,
    setGlobalSourceFilter,
    showTable,
  } = useData();

  const handleClose = () => setOpen(false);
  const handleToepassen = () => {
    const selGem = getSelGem();
    const selBench = getSelBench();
    const selInd = getSelInd();
    const selSource = getSelSource();

    if (selInd[0] !== -1) {
      setSelectedGemeente(selGem);
      setSelectedBenchmarks(selBench);
      setGlobalSourceFilter(selSource);
      setSelectedIndicators(selInd);
      setSelectedIndicator(selInd[0]);
      setOpen(false);
    } else {
      alert('Gelieve één of meerdere indicatoren te selecteren');
    }
  };

  // const selGemRef = useRef();
  // const selBenchRef = useRef();
  const selGemBenchRef = useRef();
  const selIndRef = useRef();

  const getSelGem = () => {
    const selGem: any = selGemBenchRef.current.getSelGem();
    return selGem;
  };

  const getSelBench = () => {
    const selBench: any = selGemBenchRef.current.getSelBench();
    return selBench;
  };

  const getSelInd = () => {
    const selInd: any = selIndRef.current.getSelInd();
    const indicators = selInd.filter((d: any) => {
      return d.checked === true;
    });

    indicators.sort((a: any, b: any) => {
      if (!(a && a.indicator && b && b.indicator)) return;

      const stringA = a.indicator.toUpperCase(); // ignore upper and lowercase
      const stringB = b.indicator.toUpperCase(); // ignore upper and lowercase
      if (stringA > stringB) return 1;
      if (stringA < stringB) return -1;
      return 0;
    });

    if (showTable) {
      indicators.sort((a: any, b: any) => {
        return parseInt(b?.isSurvey) - parseInt(a?.isSurvey);
      });
    }

    const unique = [...new Set(indicators.map((d: any) => d.idIndicator))];
    const out = unique.length === 0 ? [-1] : unique;
    return out;
  };

  const getSelSource = () => {
    const selSource: any = selIndRef.current.getSelSource();
    return selSource;
  };

  return (
    <>
      {themas && themas.length > 0 && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          slots={{ backdrop: Backdrop, baseTooltip: null }}
          slotProps={{
            backdrop: {
              sx: {
                zIndex: 101,
                backgroundColor: 'rgba(255, 255, 255, 0,5)',
              },
            },
          }}
        >
          <Box
            sx={{
              position: 'fixed',
              top: '0%',
              left: '50%',
              transform: 'translate(-50%, 10%)',
              maxWidth: 1000,
              maxHeight: '85%',
              height: '85%',
              width: '100%',
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              overflowY: 'auto',
              zIndex: 102,
              marginBottom: '100px',
            }}
            className={'vl-typography'}
            id="selectionScreenBox"
          >
            <Grid container>
              <Grid item xs={12}>
                <h2 style={{ fontSize: 18, width: '300px', float: 'left' }}>
                  Pas je selecties aan
                </h2>

                <button
                  onClick={handleClose}
                  style={{
                    color: interfaceColor,
                    width: '30px',
                    float: 'right',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    marginLeft: '12px',
                    position: 'relative',
                    top: '4px',
                    right: '0px',
                    fontSize: '24px',
                    border: 'none',
                  }}
                >
                  <span className="vl-button__label">
                    <MdClose />
                  </span>
                </button>

                <button
                  onClick={handleToepassen}
                  className="vl-button"
                  vl-button
                  style={{
                    backgroundColor: interfaceColor,
                    width: '140px',
                    float: 'right',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span className="vl-button__label">Toepassen</span>
                </button>

                <p style={{ clear: 'both' }}>
                  Selecteer eerst je gemeente en maximaal 5 benchmarks.
                  <br />
                  Kies vervolgens één of meerdere thema's en indicatoren.
                </p>
                <Menu
                  style={{
                    paddingTop: '24px',
                  }}
                  menuItemStyles={{
                    button: ({ level, active, disabled }) => {
                      return {
                        paddingLeft: '24px',
                        paddingRight: '24px',
                        listStyleType: 'none',
                        height: '70px',
                      };
                    },
                  }}
                >
                  <DropdownGemeenteBench
                    gemeenteLijst={gemeenteLijst}
                    selectedGemeente={selectedGemeente}
                    benchmarkLijst={benchmarkLijst}
                    selectedBenchmarks={selectedBenchmarks}
                    interfaceColor={interfaceColor}
                    d_ruimte={d_ruimte}
                    ref={selGemBenchRef}
                  />
                  {/* <DropdownGemeente
                    gemeenteLijst={gemeenteLijst}
                    selectedGemeente={selectedGemeente}
                    ref={selGemRef}
                  />
                  <DropdownBenchmarks
                    benchmarkLijst={benchmarkLijst}
                    selectedBenchmarks={selectedBenchmarks}
                    interfaceColor={interfaceColor}
                    ref={selBenchRef}
                  /> */}

                  <AccordionThema
                    themas={themas}
                    indicatorThema={indicatorThema}
                    globalSourceFilter={globalSourceFilter}
                    ref={selIndRef}
                  />

                  <MenuItem>
                    <button
                      onClick={handleToepassen}
                      className="vl-button"
                      vl-button
                      style={{
                        backgroundColor: interfaceColor,
                        float: 'right',
                        marginRight: '20px',
                        width: '140px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span className="vl-button__label">Toepassen</span>
                    </button>

                    <button
                      onClick={handleClose}
                      className="vl-button"
                      vl-button
                      style={{
                        backgroundColor: 'transparent',
                        color: interfaceColor,
                        marginRight: '20px',
                        float: 'right',
                        border: `1px solid ${interfaceColor}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span className="vl-button__label">Annuleren</span>
                    </button>
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      )}
    </>
  );
};
